// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { MessageRead } from "./MessageRead";
import {
  MessageReadFromJSON,
  MessageReadFromJSONTyped,
  MessageReadToJSON,
  MessageReadToJSONTyped,
} from "./MessageRead";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";
import type { ReactionEmojiRead } from "./ReactionEmojiRead";
import {
  ReactionEmojiReadFromJSON,
  ReactionEmojiReadFromJSONTyped,
  ReactionEmojiReadToJSON,
  ReactionEmojiReadToJSONTyped,
} from "./ReactionEmojiRead";
import type { CommentEventRead } from "./CommentEventRead";
import {
  CommentEventReadFromJSON,
  CommentEventReadFromJSONTyped,
  CommentEventReadToJSON,
  CommentEventReadToJSONTyped,
} from "./CommentEventRead";

/**
 *
 * @export
 * @interface MessagesInner
 */
export interface MessagesInner {
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  apiKeyId: string | null;
  /**
   *
   */
  creator: User;
  /**
   *
   */
  updatedAt: Date | null;
  /**
   *
   */
  body: string;
  /**
   *
   */
  deleted: boolean;
  /**
   *
   */
  edited: boolean;
  /**
   *
   */
  reactions?: Array<ReactionEmojiRead>;
  /**
   *
   */
  type: MessagesInnerTypeEnum;
}

/**
 * @export
 */
export const MessagesInnerTypeEnum = {
  Resolved: "resolved",
  Unresolved: "unresolved",
} as const;
export type MessagesInnerTypeEnum =
  (typeof MessagesInnerTypeEnum)[keyof typeof MessagesInnerTypeEnum];

/**
 * Check if a given object implements the MessagesInner interface.
 */
export function instanceOfMessagesInner(value: object): value is MessagesInner {
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("apiKeyId" in (value as Record<string, any>)) &&
      !("api_key_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["apiKeyId"] === undefined &&
      (value as Record<string, any>)["api_key_id"] === undefined)
  )
    return false;
  if (!("creator" in value) || value["creator"] === undefined) return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  if (!("deleted" in value) || value["deleted"] === undefined) return false;
  if (!("edited" in value) || value["edited"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  return true;
}

export function MessagesInnerFromJSON(json: any): MessagesInner {
  return MessagesInnerFromJSONTyped(json, false);
}

export function MessagesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessagesInner {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    apiKeyId: json["api_key_id"],
    creator: UserFromJSON(json["creator"]),
    updatedAt: json["updated_at"] == null ? null : parseDateTime(json["updated_at"]),
    body: json["body"],
    deleted: json["deleted"],
    edited: json["edited"],
    reactions:
      json["reactions"] == null
        ? undefined
        : (json["reactions"] as Array<any>).map(ReactionEmojiReadFromJSON),
    type: json["type"],
  };
}

export function MessagesInnerToJSON(json: any): MessagesInner {
  return MessagesInnerToJSONTyped(json, false);
}

export function MessagesInnerToJSONTyped(
  value?: MessagesInner | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    api_key_id: value["apiKeyId"],
    creator: UserToJSON(value["creator"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    body: value["body"],
    deleted: value["deleted"],
    edited: value["edited"],
    reactions:
      value["reactions"] == null
        ? undefined
        : (value["reactions"] as Array<any>).map(ReactionEmojiReadToJSON),
    type: value["type"],
  };
}
